module.exports = __webpack_public_path__ + "static/office-portrait-78b319dcb70781e6f43b24f6ce389639.jpg";